
export const postdata = [
    {
        id: 1,
        posts: [
            {
                post_id: 0,
                post: "Hi am Jade",
                comment: [
                    {
                        comment_id: 0,
                        comment1: 'hi',
                        replies: [
                            {
                                reply_id: 0,
                                reply1: 'Hi Everyone!'
                            }
                        ]
                        
                    },
                    {
                        comment_id: 1,
                        comment1: 'Nice to meet you!',
                        replies: [
                            {
                                reply_id: 0,
                                reply1: 'Hello!'
                            },
                            {
                                reply_id: 1,
                                reply1: 'Hi'
                            }
                        ]
                    }
                ]
            },
            {
                post_id: 1,
                post: "Feeling good",
                comment: [
                    {
                        comment_id: 0,
                        comment1: 'hi',
                        replies: [
                            
                        ]
                    },
                    {
                        comment_id: 1,
                        comment1: 'good',
                        replies: [
                            {
                                reply_id: 0,
                                reply1: 'nice!'
                            },
                            {
                                reply_id: 1,
                                reply1: 'thank you'
                            }
                        ]
                    },
                ]
            }
            ,
            {
                post_id: 2,
                post: "Hi!",
                comment: [
                    {
                        comment_id: 0,
                        comment1: 'hi',
                        replies: [
                            
                        ]
                    }
                ]
            }
            ,
            {
                post_id: 3,
                post: "Hello World!",
                comment: [
                    {
                        comment_id: 0,
                        comment1: 'hi',
                        replies: [
                            
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 2,
        posts: [
            {
                post_id: 0,
                post: "Hi im mark",
                comment: []
            }
        ]
    },
    {
        id: 3,
        posts: [
            {
                post_id: 0,
                post: "Hi my name is bill",
                comment: []
            }
        ]
    } 

];
